import { NavLink } from 'react-router';
import { t } from '../../i18n';

/** The call-flow pages: the flows, and what they are built from. */
export function SectionTabs() {
  return (
    <nav className="section-tabs" aria-label={t('Call flows')}>
      <NavLink to="/flows" end>
        {t('Flows')}
      </NavLink>
      <NavLink to="/prompts">{t('Prompts')}</NavLink>
      <NavLink to="/hold-music">{t('Hold music')}</NavLink>
      <NavLink to="/opening-hours">{t('Opening hours')}</NavLink>
      <NavLink to="/caller-lists">{t('Caller lists')}</NavLink>
    </nav>
  );
}
